import {Accordion, AccordionDetails, AccordionSummary, Grid, InputAdornment, Typography, useTheme} from "@mui/material";
import {FormTextField} from "../../../../common/form-fields";
import {useTranslation} from "react-i18next";
import React, {useEffect} from "react";
import {ExpandMore} from "@mui/icons-material";
import {FormRateModel} from "../../../../api/types/rate";
import {useRecoilState} from "recoil";
import {rateAccordionExpandedState} from "../../../../state/ratesRecoil";
import {FormElementI} from "../../../../api/types/generic";
import {useFormContext} from "react-hook-form";
import {setFormNumberValue} from "../../../../utils";
import {numberIntegerRegex} from "../../../../constants";

const AdvancedBookingComponent = ({
                                      threshold,
                                      discountRate
                                  }: {
    threshold: FormElementI<string>
    discountRate: FormElementI<string>
}) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Theme
    const theme = useTheme();

    // Use Form Context
    const {formState: {isSubmitting, errors}, register, setValue, getValues} = useFormContext<FormRateModel>();

    // Use Recoil
    const [advancedBookingExpanded, setAdvancedBookingExpanded] = useRecoilState(rateAccordionExpandedState("advancedBooking"));

    // Use Effect
    useEffect(() => {
        if (!isSubmitting && errors.advancedBooking)
            setAdvancedBookingExpanded(true);
        // eslint-disable-next-line
    }, [isSubmitting]);

    return (
        <Accordion expanded={advancedBookingExpanded}
                   onChange={(e, expanded) => setAdvancedBookingExpanded(expanded)}
        >
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Typography sx={{color: theme.palette.primary.dark}}>
                    {t("pricing:rate.form.labels.advancedBooking")}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                {/* ADVANCED BOOKING */}
                <Grid container rowSpacing={2} columnSpacing={3}>
                    <Grid item xs={12} md={6}>
                        <FormTextField
                            {...register("advancedBooking.threshold")}
                            label={`${t("pricing:rate.form.labels.advancedBookingLabels.threshold")}`}
                            readOnly={threshold.readonly}
                            type={"text"}
                            handleChange={(value: string) => setFormNumberValue(value, setValue, "advancedBooking.threshold", numberIntegerRegex)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {/* DISCOUNT RATE */}
                        <FormTextField
                            {...register("advancedBooking.discountRate")}
                            label={`${t("pricing:rate.form.labels.advancedBookingLabels.discountRate")}`}
                            readOnly={!Boolean(getValues().advancedBooking.threshold) || discountRate.readonly}
                            type={"text"}
                            handleChange={(value: string) => setFormNumberValue(value, setValue, "advancedBooking.discountRate", numberIntegerRegex)}
                            startAdornment={<InputAdornment position="start">%</InputAdornment>}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default AdvancedBookingComponent;